import { slugs } from 'common/constants/inputTypes'
import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import ColumnOld from 'publisher/components/ColumnOld'
import AudioNew from 'publisher/components/entities/AudioNew'
import { Body } from 'publisher/components/entities/body'
import BookingCalendar from 'publisher/components/entities/booking-calendar/index'
import ContentTable from 'publisher/components/entities/ContentTable'
import Countdown from 'publisher/components/entities/Countdown'
import BaseField from 'publisher/components/entities/Field/BaseField'
import CountryField from 'publisher/components/entities/Field/CountryField'
import EmailField from 'publisher/components/entities/Field/EmailField'
import PhoneNumberField from 'publisher/components/entities/Field/PhoneNumberField'
import Image from 'publisher/components/entities/Image'
import InlineBody from 'publisher/components/entities/inline-body'
import NewBulletList from 'publisher/components/entities/NewBulletList'
import NewCustomLogin from 'publisher/components/entities/NewCustomLogin'
import NewHorizontalLine from 'publisher/components/entities/NewHorizontalLine'
import OfferThankYouOrderSummaryNew from 'publisher/components/entities/OfferThankYouOrderSummaryNew'
import OptInButton from 'publisher/components/entities/OptInButton'
import { PopupNew } from 'publisher/components/entities/popup-new'
import RemotePopupBody from 'publisher/components/entities/remote-popup-body'
import SectionOld from 'publisher/components/entities/Section/SectionOld'
import StartTimer from 'publisher/components/entities/StartTimer'
import SurveyNew from 'publisher/components/entities/Survey/SurveyNew'
import TextNew from 'publisher/components/entities/TextNew'
import TwitterTweetButton from 'publisher/components/entities/TwitterTweetButton'
import VideoNew from 'publisher/components/entities/Video'
import RowOld from 'publisher/components/RowOld'
import React from 'react'
import { Agreement } from 'src/publisher/entities/agreement'
import OptInButtonNew from 'src/publisher/entities/button-new'
import { Carousel } from 'src/publisher/entities/carousel'
import Checkbox from 'src/publisher/entities/checkbox/checkbox'
import { Faq } from 'src/publisher/entities/faq'
import BaseFieldNew from 'src/publisher/entities/field-new/base-field'
import CountryFieldNew from 'src/publisher/entities/field-new/country-field'
import EmailFieldNew from 'src/publisher/entities/field-new/email-field'
import PhoneNumberFieldNew from 'src/publisher/entities/field-new/phone-number-field'
import { Form } from 'src/publisher/entities/form'
import { Menu } from 'src/publisher/entities/menu'
import ContactUsButton from 'src/publisher/pages/contact-us/entities/contact-us-button'
import { ContactUsField } from 'src/publisher/pages/contact-us/entities/contact-us-field'
import SalesRedirectionButtonNew from 'src/publisher/pages/sales/entities/sales-redirection-button'
import Breadcrumbs from '../../components/entities/Breadcrumbs'
import Column from '../../components/entities/Column'
import ContentBox from '../../components/entities/ContentBox'
import CustomLoginForgotPassword from '../../components/entities/CustomLoginForgotPassword'
import PasswordField from '../../components/entities/Field/PasswordField'
import Headline from '../../components/entities/Headline'
import NewLanguageSwitcher from '../../components/entities/NewLanguageSwitcher'
import NewRawHtml from '../../components/entities/NewRawHtml'
import OptInRecaptcha from '../../components/entities/OptInRecaptcha'
import Row from '../../components/entities/Row'
import Section from '../../components/entities/Section'
import Attachments from '../../pages/contact-us/components/Attachments'
import ContactUs from '../../pages/contact-us/components/ContactUs'
import Recaptcha from '../../pages/contact-us/components/Recaptcha'
import TextArea from '../../pages/contact-us/components/TextArea'
import Product from '../../pages/offer-page/components/Product'
import PriceElement from '../../pages/sale-page/components/price-element'

export const createEntityElement = () => {
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  return (entity: any, additionalProps = {}) => {
    const key = `entity-${entity.id}`
    switch (entity.type) {
      case EntityTypeEnum.Body:
        return <Body entity={entity} key={key} />
      case structureTypes.SECTION:
        return <SectionOld entity={entity} key={key} />
      case structureTypes.ROW:
        return <RowOld entity={entity} key={key} />
      case structureTypes.COLUMN:
        return <ColumnOld entity={entity} key={key} {...additionalProps} />
      case EntityTypeEnum.Section:
        return <Section entity={entity} key={key} />
      case EntityTypeEnum.Row:
        return <Row entity={entity} key={key} />
      case EntityTypeEnum.Column:
        return <Column entity={entity} key={key} {...additionalProps} />
      case EntityTypeEnum.BulletList:
        return <NewBulletList entity={entity} key={key} />
      case EntityTypeEnum.BookingCalendar:
        return <BookingCalendar entity={entity} key={key} />
      case structureTypes.BUTTON:
        return <OptInButton entity={entity} key={key} />
      case EntityTypeEnum.Button:
        return <OptInButtonNew entity={entity} key={key} />
      case structureTypes.FORM_INPUT:
        switch (entity.options.slug) {
          case slugs.EMAIL:
            return <EmailField entity={entity} />
          case slugs.COUNTRY:
            return <CountryField entity={entity} />
          case slugs.PHONE_NUMBER:
            return <PhoneNumberField entity={entity} />
          case slugs.PASSWORD:
          case slugs.CONFIRM_PASSWORD:
            return <PasswordField entity={entity} />
          default:
            return <BaseField entity={entity} />
        }
      case EntityTypeEnum.Field:
        switch (entity.slug) {
          case slugs.EMAIL:
            return <EmailFieldNew entity={entity} />
          case slugs.COUNTRY:
            return <CountryFieldNew entity={entity} />
          case slugs.PHONE_NUMBER:
            return <PhoneNumberFieldNew entity={entity} />
          case slugs.PASSWORD:
          case slugs.CONFIRM_PASSWORD:
            return <BaseFieldNew entity={entity} type="password" />
          default:
            return <BaseFieldNew entity={entity} key={key} />
        }
      case EntityTypeEnum.Form:
        return <Form entity={entity} key={key} />
      case EntityTypeEnum.RemotePopupBody:
        return (
          <RemotePopupBody entity={entity} key={key} {...additionalProps} />
        )
      case structureTypes.INLINE:
        return <div /> // removed
      case EntityTypeEnum.InlineBody:
        return <InlineBody entity={entity} key={key} />
      case EntityTypeEnum.CustomLogin:
        return <NewCustomLogin entity={entity} key={key} />
      case EntityTypeEnum.CustomLoginForgotPassword:
        return <CustomLoginForgotPassword entity={entity} key={key} />
      case EntityTypeEnum.OrderSummary:
        return <OfferThankYouOrderSummaryNew entity={entity} key={key} />
      case EntityTypeEnum.ContentBox:
        return <ContentBox entity={entity} key={key} />
      case EntityTypeEnum.RawHtml:
        return <NewRawHtml entity={entity} key={key} />
      case EntityTypeEnum.Checkbox:
        return <Checkbox entity={entity} key={key} />
      case structureTypes.START_TIMER:
        return <StartTimer entity={entity} key={key} />
      case EntityTypeEnum.Countdown:
        return <Countdown entity={entity} key={key} />
      case EntityTypeEnum.Menu:
        return <Menu entity={entity} key={key} />
      case EntityTypeEnum.LanguageSwitcher:
        return <NewLanguageSwitcher entity={entity} key={key} />
      case EntityTypeEnum.PriceElement:
        return <PriceElement entity={entity} key={key} />
      case EntityTypeEnum.HorizontalLine:
        return <NewHorizontalLine entity={entity} key={key} />
      case EntityTypeEnum.TwitterTweetButton:
        return <TwitterTweetButton entity={entity} key={key} />
      case EntityTypeEnum.Survey:
        return <SurveyNew entity={entity} key={key} />
      case EntityTypeEnum.Carousel:
        return <Carousel entity={entity} key={key} />
      case EntityTypeEnum.Faq:
        return <Faq entity={entity} key={key} />
      case EntityTypeEnum.Text:
        return <TextNew entity={entity} key={key} />
      case EntityTypeEnum.Headline:
        return <Headline entity={entity} key={key} />
      case EntityTypeEnum.ContentTable:
        return <ContentTable entity={entity} key={key} />
      case EntityTypeEnum.ContactUs:
        return <ContactUs entity={entity} key={key} />
      case EntityTypeEnum.ContactUsField:
        return <ContactUsField entity={entity} key={key} />
      case EntityTypeEnum.ContactUsButton:
        return <ContactUsButton entity={entity} key={key} />
      case EntityTypeEnum.Recaptcha:
      case EntityTypeEnum.ContactUsRecaptcha:
        return <Recaptcha entity={entity} key={key} />
      case EntityTypeEnum.OptInRecaptcha:
        return <OptInRecaptcha entity={entity} key={key} />
      case EntityTypeEnum.TextArea:
        return <TextArea entity={entity} key={key} />
      case EntityTypeEnum.Breadcrumbs:
        return <Breadcrumbs entity={entity} key={key} />
      case EntityTypeEnum.Attachments:
        return <Attachments entity={entity} key={key} />
      case EntityTypeEnum.Video:
        return <VideoNew entity={entity} key={key} />
      case EntityTypeEnum.Image:
        return <Image entity={entity} key={key} />
      case EntityTypeEnum.Audio:
        return <AudioNew entity={entity} key={key} />
      case EntityTypeEnum.Agreement:
        return <Agreement entity={entity} key={key} />
      case EntityTypeEnum.Popup:
        return <PopupNew entity={entity} key={key} {...additionalProps} />
      case EntityTypeEnum.SalesRedirectionButton:
        return <SalesRedirectionButtonNew entity={entity} key={key} />
      case EntityTypeEnum.Product:
        return <Product entity={entity} key={key} />
      default:
        return <div /> /* let's return empty div temporarily */
      // throw new Error(`unknown type ${entity.type} of node id = ${entity.id}`)
    }
  }
}
